import React, { useState, useEffect, useContext, useRef } from "react";
import { AuthContext } from "../../../context/AuthContext";
import { viewportContext } from "../../../context/ViewportContext";
import Avatar from "@material-ui/core/Avatar";
import Button from "@material-ui/core/Button";
import CssBaseline from "@material-ui/core/CssBaseline";
import TextField from "@material-ui/core/TextField";
import Grid from "@material-ui/core/Grid";
import Typography from "@material-ui/core/Typography";
import { makeStyles } from "@material-ui/core/styles";
import Container from "@material-ui/core/Container";
import { Dialog, DialogContent, IconButton } from "@material-ui/core";

import { useFormik } from "formik";
import * as Yup from "yup";
import ButtonTextLoading from "../Shared/ButtonTextLoading";
import {
  getUserById,
  getUserGroupById,
  updateProfile,
  uploadProfilePicture,
} from "../../../service/endpoint-manager";
import { useSnackbar } from "notistack";
import Loading from "../Shared/Loading";
import ResetPassword from "../Register/ResetPassword";

import styles from "../../../styles.module.css"; // Importing CSS module for styles.

const useStyles = makeStyles((theme) => ({
  input: {
    display: "none",
  },
}));

const Profile = ({ openSidebar }) => {
  const [isLoading, setIsLoading] = useState(false);
  const { account } = useContext(AuthContext);
  const { screenType } = useContext(viewportContext);

  const classes = useStyles();
  const [user, setUser] = useState(null);
  const [userName, setUserName] = useState(null);
  // const [dob, setDOB] = React.useState({
  //   date: null,
  //   selectedDate: `${getInitialRenderDate()}`,
  // });

  const [uploadedFileURL, setUploadedFileURL] = useState(null);
  const [uploadedFile, setUploadedFile] = useState(null);
  const [profilePicture, setProfilePicture] = useState(null);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [userGroupName, setUserGroupName] = useState(false);
  const { enqueueSnackbar } = useSnackbar();
  const ref = useRef(null);

  const [openResetPasswordDialog, setOpenResetPasswordDialog] =
    React.useState(false);

  // method to handle opening ResetPassword dialog
  const handleOpenResetPasswordDialog = () => {
    setOpenResetPasswordDialog(true);
  };

  // method to handle closing ResetPassword dialog
  const handleCloseResetPasswordDialog = () => {
    setOpenResetPasswordDialog(false);
  };

  useEffect(() => {
    const userStorage = JSON.parse(localStorage.getItem("user-profile"));
    const getUser = async () => {
      setIsLoading(true);
      const result = await getUserById(userStorage.user_id);

      if (result?.status === 200) {
        setUser(result.data?.body?.userData);
        setUserName(result.data?.body?.userData?.userName);
        // setDOB({ ...dob, selectedDate: result?.data?.body?.userData?.dob });
      }
      setIsLoading(false);
    };
    getUser();
  }, []);

  // get userGroup name on page load

  useEffect(() => {
    const getUserGroupName = async () => {
      if (user?.userGroup) {
        const result = await getUserGroupById(user?.userGroup);
        setUserGroupName(result?.data?.body?.name);
      }
    };

    getUserGroupName();
  }, [user]);

  useEffect(() => {
    const userProfile = JSON.parse(localStorage.getItem("user-profile"));
    setProfilePicture(userProfile?.profilePic);
  }, []);

  const fileSelectedHandler = async (e) => {
    if (e.target.files[0] !== null) {
      let uploadedFileURL = null;

      let reader = new FileReader();
      reader.addEventListener(
        "load",
        function () {
          uploadedFileURL = reader.result;
        },
        false
      );
      if (e.target.files[0]) {
        reader.readAsDataURL(e.target.files[0]);
      }
      setUploadedFile(e.target.files[0]);
      const result = await uploadProfilePicture(
        e.target.files[0],
        user?.user_id
      );

      if (result?.status === 200) {
        setIsLoading(true);

        setProfilePicture(result?.data?.body?.picture);
        const updatedUserProfile = {
          ...account?.data?.body?.userData,
          profilePic: uploadedFileURL,
        };

        // set localstorage after updating userProfile
        localStorage.setItem(
          "user-profile",
          JSON.stringify(updatedUserProfile)
        );

        enqueueSnackbar(`${result?.data?.message}`, { variant: "success" });
        setIsLoading(false);
      } else {
        enqueueSnackbar(`${result?.response?.data?.message}`, {
          variant: "error",
        });
      }
    }
  };

  const formik = useFormik({
    innerRef: ref,
    enableReinitialize: true,
    initialValues: {
      username: user?.userName,
      fullName: user?.fullName,
      userGroup: userGroupName,
    },
    onSubmit: async function (values) {},

    // validation schema for formik using yup
    validationSchema: Yup.object({
      // name must be text only and is required
      fullName: Yup.string()
        .matches(/^[a-zA-Z]+(?:[\s.]+[a-zA-Z]+)*$/, "name must be text only")
        .label("Full Name")
        .required("Full name is required"),

      // username must be 6-20 and is required
      username: Yup.string()
        .min(6, "At least 6 characters required")
        .max(20)
        .required("Username is required"),
    }),
  });

  if (isLoading) {
    return <Loading />;
  }

  const handleUpdateProfile = async () => {
    setIsSubmitting(true);

    delete formik.values.email;
    formik.values.updatedUsername = formik.values.username;

    const result = await updateProfile(userName, formik.values, user?.user_id);
    if (result?.status === 200) {
      enqueueSnackbar(`${result?.data?.message}`, {
        variant: "success",
      });
    } else {
      enqueueSnackbar(`${result?.response?.data?.message}`, {
        variant: "error",
      });
    }

    setIsSubmitting(false);
  };

  return (
    <Container
      component="main"
      maxWidth="xs"
      style={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        marginLeft: openSidebar ? "250px" : "0", // Adjust the left margin based on sidebar state
        transition: "margin-left 0.3s ease", // Add a transition for smooth animation
        minWidth: screenType.isMobile ? "400px" : "480px",
      }}
    >
      <CssBaseline />
      <div className={styles.flexColumnCenter}>
        <Typography
          classes={styles.userProfileTitle}
          component="h1"
          variant="h5"
        >
          User Profile
        </Typography>
        <form className={styles.userProfileMargin10} noValidate>
          <Grid container spacing={2}>
            {/* profile picture */}

            <Grid
              item
              xs={12}
              className={
                screenType?.isMobile
                  ? styles.flexColumnCenter
                  : styles.flexCenter
              }
            >
              <span style={{ justifyContent: "flex-start" }}>
                <input
                  accept="image/*"
                  className={classes.input}
                  id="icon-button-file"
                  type="file"
                  onChange={(e) => {
                    fileSelectedHandler(e);
                  }}
                />
                <label htmlFor="icon-button-file">
                  <IconButton
                    color="primary"
                    aria-label="upload picture"
                    component="span"
                    disableRipple
                    disableFocusRipple
                    disableTouchRipple
                  >
                    <Avatar
                      src={
                        uploadedFileURL ||
                        profilePicture ||
                        "https://www.w3schools.com/howto/img_avatar.png"
                      }
                      className={styles.profileAvatar}
                    />
                  </IconButton>
                </label>
              </span>
              <span
                className={
                  screenType.isMobile ? { display: "flex" } : styles.floatLeft
                }
              >
                {user?.fullName || "No name available"}
              </span>
            </Grid>
            {/* fullName */}
            <Grid item xs={12}>
              <TextField
                error={formik.touched.fullName && formik.errors.fullName}
                required
                fullWidth
                id="fullName"
                label="Full Name"
                name="fullName"
                autoComplete="fullName"
                variant="outlined"
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                value={formik.values.fullName}
                className={screenType.isMobile ? "" : styles.floatRight70}
              />
              {
                <div
                  style={{
                    color: "red",
                    fontSize: "0.6rem",
                    visibility:
                      formik.touched.fullName && formik.errors.fullName
                        ? "visible"
                        : "hidden",
                  }}
                >
                  {formik.errors.fullName || "Full Name is required"}
                </div>
              }
            </Grid>
            {/* username */}
            <Grid item xs={12}>
              <TextField
                error={formik.touched.username && formik.errors.username}
                required
                fullWidth
                id="username"
                label="Username"
                name="username"
                autoComplete="username"
                variant="outlined"
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                value={formik.values.username}
                className={screenType.isMobile ? "" : styles.floatRight70}
              />
              {
                <div
                  style={{
                    color: "red",
                    fontSize: "0.6rem",
                    visibility:
                      formik.touched.username && formik.errors.username
                        ? "visible"
                        : "hidden",
                  }}
                >
                  {formik.errors.username || "Username required"}
                </div>
              }
            </Grid>

            {/* userGroup */}
            <Grid item xs={12}>
              <TextField
                error={formik.touched.userGroup && formik.errors.userGroup}
                required
                fullWidth
                id="userGroup"
                label="User Group"
                disabled={true}
                name="userGroup"
                autoComplete="userGroup"
                type="userGroup"
                variant="outlined"
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                value={formik.values.userGroup}
                className={screenType.isMobile ? "" : styles.floatRight70}
              />
              {
                <div
                  style={{
                    color: "red",
                    fontSize: "0.6rem",
                    visibility:
                      formik.touched.userGroup && formik.errors.userGroup
                        ? "visible"
                        : "hidden",
                  }}
                >
                  {formik.errors.userGroup || "User Group Required"}
                </div>
              }
            </Grid>
          </Grid>

          <div className={styles.buttonDiv}>
            {/* Reset Password button */}
            <Button
              type="submit"
              fullWidth
              variant="contained"
              color="primary"
              className={`${styles.secondaryButton} ${styles.resetButton}`}
              onClick={(e) => {
                e.preventDefault();
                handleOpenResetPasswordDialog();
              }}
            >
              Reset Password
            </Button>
            {/* submit button */}
            <Button
              type="submit"
              fullWidth
              variant="contained"
              color="primary"
              className={`${styles.primaryButton} ${styles.saveButton}`}
              disabled={isSubmitting}
              onClick={(e) => {
                e.preventDefault();
                handleUpdateProfile();
              }}
            >
              <ButtonTextLoading isSubmitting={isSubmitting} body={"Save"} />
            </Button>
          </div>
        </form>
      </div>

      <Dialog
        scroll="paper"
        open={openResetPasswordDialog}
        onClose={handleCloseResetPasswordDialog}
        maxWidth="lg"
        className={styles.dialogStyles}
      >
        <DialogContent className={styles.flexCenter}>
          <ResetPassword
            handleCloseResetPasswordDialog={handleCloseResetPasswordDialog}
            userName={userName}
          />
        </DialogContent>
      </Dialog>
    </Container>
  );
};

export default Profile;
